import { shape } from 'prop-types';
import UIIcon from 'components/UI/Icon/Icon';
import checkIconImg from 'components/assets/img/check_icon.png';
import { toKeysMap } from 'utils/array';
import { PLACEMENT_QUALITY_ATTRIBUTE } from 'components/Placement/constants';

import './Attributes.scss';

const cbn = 'placement-view-attributes';

const hasSelectedChildren = (children, attributes) =>
  Object.entries(children).some(([childAttrKey]) => attributes[childAttrKey]);

const qualityAttrsMap = toKeysMap(
  PLACEMENT_QUALITY_ATTRIBUTE,
  'key',
  (item) => {
    const newItem = { ...item };
    if (newItem.children) {
      newItem.children = toKeysMap(newItem.children, 'key');
    }
    return newItem;
  },
);

function PlacementViewAttributes({ attributes }) {
  const qualityAttributes = attributes
    ? Object.entries(attributes).filter(
        ([attr, value]) => value && qualityAttrsMap[attr],
      )
    : [];

  if (!qualityAttributes.length) {
    return null;
  }

  return (
    <div className={cbn}>
      <ul className={`${cbn}__quality__list`}>
        {qualityAttributes.map(([attrKey]) => (
          <li className={`${cbn}__quality__list-item`} key={attrKey}>
            <img
              className={`${cbn}__quality__list-item__print-icon`}
              src={checkIconImg}
              alt="checked"
            />
            <UIIcon type="check" />
            {qualityAttrsMap[attrKey].label}
            {qualityAttrsMap[attrKey].children &&
              hasSelectedChildren(
                qualityAttrsMap[attrKey].children,
                attributes,
              ) && (
                <ul>
                  {qualityAttrsMap[attrKey].children && (
                    <>
                      {Object.entries(qualityAttrsMap[attrKey].children).map(
                        ([childAttrKey]) => (
                          // eslint-disable-next-line
                          <>
                            {attributes[childAttrKey] && (
                              <li key={childAttrKey}>
                                {
                                  qualityAttrsMap[attrKey].children[
                                    childAttrKey
                                  ].label
                                }
                              </li>
                            )}
                          </>
                        ),
                      )}
                    </>
                  )}
                </ul>
              )}
          </li>
        ))}
      </ul>
    </div>
  );
}

PlacementViewAttributes.propTypes = {
  attributes: shape({}),
};

PlacementViewAttributes.defaultProps = {
  attributes: {},
};

export default PlacementViewAttributes;
